import percentRound from 'percent-round';

export type HistogramDataPoint = {
  capNumber: number;
  percentage: number;
};

const threshold = 0.05;

export const calcTotalAdjustableNumbers = (dataSet: HistogramDataPoint[]) => {
  return dataSet.reduce((acc, curr) => {
    if (curr.percentage < threshold) {
      return acc + 1;
    }
    return acc;
  }, 0);
};

export const calcSumOfAdjustableNumbers = (dataSet: HistogramDataPoint[]) => {
  return dataSet.reduce((acc, curr) => {
    if (curr.percentage > threshold) {
      return acc + curr.percentage;
    }
    return acc;
  }, 0);
};

// Scan data for values less than threshold
export const getAdjustableRatio = (dataSet: HistogramDataPoint[]) => {
  const numberOfAdjustable = calcTotalAdjustableNumbers(dataSet);
  const sumOfAdjustable = calcSumOfAdjustableNumbers(dataSet);
  const totalAdjustableSize = 1 - numberOfAdjustable * threshold;
  return totalAdjustableSize / sumOfAdjustable;
};

export const enhanceWithSizePercentage = (ratio: number, dataSet: HistogramDataPoint[]) => {
  return dataSet.map((dataItem) => {
    if (dataItem.percentage > threshold) {
      return {
        ...dataItem,
        sizePercentage: dataItem.percentage * ratio,
      };
    }
    return {
      ...dataItem,
      sizePercentage: threshold,
    };
  });
};

const minVisualValue = 1;
export const toPercentDisplay = (data: number) => {
  if (data < minVisualValue) {
    return `< ${minVisualValue}%`;
  }
  return `${Math.trunc(data)}%`;
};

export const transformToVisualPercents = (dataSet: HistogramDataPoint[]) => {
  const adjustableRatio = getAdjustableRatio(dataSet);
  const enhancedPercents = enhanceWithSizePercentage(adjustableRatio, dataSet);

  const justPercents = enhancedPercents.map((p) => p.percentage);
  const roundedPercents = percentRound(justPercents);

  return enhancedPercents.map((p, i) => {
    return {
      ...p,
      percentage: toPercentDisplay(roundedPercents[i]),
    };
  });
};
